import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { CustomEase } from "gsap/CustomEase";
import { Draggable } from "gsap/Draggable";
import * as Tone from 'tone';



// Svg
// https://parceljs.org/languages/svg/#inlining-as-a-string
// import playSvg from 'bundle-text:../../svg/play.svg';
// import eyeSvg from 'bundle-text:../../svg/eyeFrame.svg';
// import eyeSvgTwo from 'bundle-text:../../svg/eyeFrame__elements.svg';
import handSvg from 'bundle-text:../../svg/hand_c.svg';
import sliderSvg from 'bundle-text:../../svg/rangeSliderTwo.svg';
// CSS
import '../../styles/components/hand.scss';

// Ready
document.addEventListener('DOMContentLoaded', function () {


    gsap.registerPlugin(CustomEase, MorphSVGPlugin, Draggable);





    // Inject Play Svg
    const playSpans = document.querySelectorAll('#playSpans span');
    playSpans.forEach(function (handSpan) {
        handSpan.innerHTML = playSvg;
    });



    // Hand

    // Inject Slider Svg
    const sliderSpans = document.querySelectorAll('#slider span');
    sliderSpans.forEach(function (sliderSpan) {
        sliderSpan.innerHTML = sliderSvg;
    });

    // Inject Hand Svg
    const handSpans = document.querySelectorAll('#hand span');
    handSpans.forEach(function (handSpan) {
        handSpan.innerHTML = handSvg;
    });


    // Animate
    gsap.set(".circlePalm", {
        transformOrigin: "center center",
        scale: 1.14
    });
    gsap.set(".squarePalm", {
        transformOrigin: "center center",
        scale: 1.14,
        autoAlpha: 0,
    });

    gsap.set("#theHand", {
        transformOrigin: "center center",
        y: 10,
        autoAlpha: 0,
    });

    gsap.to("#theHand", {
        duration: 0.25,
        delay: 1,
        y: "-=15",
        autoAlpha: 1,
    });

    theHand.addEventListener('mouseenter', function () {
        // gsap.to(".circlePalm", {
        //     duration: 0.3,
        //     scale: 3,
        //     ease:
        //         CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        // });
        gsap.to(".squarePalm", {
            duration: 0.2,
            scale: 3,
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });

        gsap.to("#theHand", {
            duration: 0.5,
            y: "-=5",
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });
    });

    // Trigger Animation
    theHand.addEventListener('mouseleave', function () {
        // gsap.to(".circlePalm", {
        //     duration: 0.1,
        //     scale: 1.1,
        // });
        gsap.to("#FingersPalm", {
            duration: 0.1,
        });
        gsap.to(theHand, {
            duration: 0.3,
            y: "+=5",
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        });
    });



    // Sound 
    Tone.Transport.timeSignature = [4, 4];
    Tone.Transport.bpm.value = 226;

    const merge = new Tone.Merge();
    const reverb = new Tone.Reverb({
        wet: 1,
        decay: 1.5,
    });
    const filter = new Tone.Filter(1000, 'lowpass').toDestination();
    const feedbackDelay = new Tone.FeedbackDelay(0.025, 0.25).toDestination();
    merge.chain(reverb, Tone.Destination);
    merge.chain(filter, Tone.Destination);
    merge.chain(feedbackDelay, Tone.Destination);


    // const synthL = new Tone.Synth({
    //     oscillator: {
    //         type: "amsine2",
    //         modulationType: "sine",
    //         harmonicity: 1.01
    //     },
    //     envelope: {
    //         attack: 0.000125,
    //         decay: 0.01,
    //         sustain: 0.002,
    //         release: 0.04,
    //     },
    //     portamento: 11.2,
    //     volume: -5
    // }).connect(merge, 0, 0);

    // const synthR = new Tone.Synth({
    //     oscillator: {
    //         type: "amsine2",
    //         modulationType: "sine",
    //         harmonicity: 1
    //     },
    //     envelope: {
    //         attack: 0.000125,
    //         decay: 0.01,
    //         sustain: 0.002,
    //         release: 0.04,
    //     },
    //     portamento: 12.4,
    //     volume: -5
    // }).connect(merge, 0, 1);

    const synthL = new Tone.FMSynth({
        harmonicity: 3.5,
        modulationIndex: 1,
        oscillator: {
            type: "sine1"
        },
        envelope: {
            attack: 1,
            decay: 1,
            sustain: 0.5,
            release: 2
        }
    }).connect(merge, 0, 0);

    const synthR = new Tone.FMSynth({
        harmonicity: 3.5,
        modulationIndex: 1,
        oscillator: {
            type: "sine2"
        },
        envelope: {
            attack: 1,
            decay: 1,
            sustain: 0.5,
            release: 2
        }
    }).connect(merge, 0, 1);

    const chordProgressionL = [
        ["c2", "G2", "G2", "G2",],

    ];

    // const chordProgressionO = [
    //     ["B1", "C1", "D1", "A1"],
    //     ["G1", "C1", "G1", "C1"],
    // ];
    const chordProgressionR = [
        ["g2", "G2", "g2", "G2",],

    ];

    const partL = new Tone.Sequence(((time, chord) => {
        synthL.triggerAttackRelease(chord, "4n", time);
    }), chordProgressionL.flat(), "4n").start();

    const partR = new Tone.Sequence(((time, chord) => {
        synthR.triggerAttackRelease(chord, "4n", time);
    }), chordProgressionR.flat(), "4n").start();

    // const partO = new Tone.Sequence(((time, chord) => {
    //     synthO.triggerAttackRelease(chord, "8n", time);
    // }), chordProgressionO.flat(), "4n").start(1m);

    // partR.playbackRate = 1.025;
    partR.playbackRate = 1.0125;

    const totalDurationL = partL.length * (60 / Tone.Transport.bpm.value);
    const totalDurationR = partR.length * (60 / Tone.Transport.bpm.value);

    // New Animation Logic 
    const arptl = gsap.timeline({
        paused: true,

        // reversed: true 
    });

    gsap.set("#left, #right", {
        transformOrigin: "center",
        scaleX: 1,
        opacity: 1,
    });
    gsap.set(".dot", {
        transformOrigin: "center",
        scale: 1,
        opacity: 1,
    });

    arptl
        .addLabel("start", 0)

        .to("#left", {
            rotate: 360,
            duration: 0.2,
            ease: "none",
        }, "start")
        // .to(".--left .dot", {
        //     opacity: 1,
        //     scale: 0,
        //     duration: 0.2,
        //     ease:
        //         CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        // }, "start")
        ;

    arptl.duration(totalDurationL);

    const arptlTT = gsap.timeline({
        paused: true,
    });

    arptlTT
        .addLabel("start", 0)


        .to("#right", {
            opacity: 1,
            rotate: 360,
            duration: 0.2,
            ease: "none",
        })
        .to(".--right .dot", {
            opacity: 1,
            scale: 0,
            duration: 0.2,
            ease:
                CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
        }, "start")

        ;

    arptlTT.duration(totalDurationR);

    function loop() {
        requestAnimationFrame(loop);

        // Sync GSAP animation with Tone.js sequence
        arptl.progress(partL.progress);
        arptlTT.progress(partR.progress);
    }
    loop();

    gsap.to("#right, #left", {
        rotate: -360,
        duration: 1.5,
        yoyo: true,
        repeat: 0,
        ease:
            CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
    });






    gsap.set(".__player.__hand #hand span svg#theHand", {
        transformOrigin: "center",
    });


    Draggable.create(hand, {
        type: "x,y",
        edgeResistance: 2.2,
        bounds: "article",
        throwProps: true,
        allowEventDefault: true,
        onDrag: function () {

            gsap.to(".handLayer", {
                duration: 0.2,
                rotate: "-2deg",
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
        },
        onDragEnd: function () {

            gsap.to(".handLayer", {
                duration: 0.2,
                rotate: 0,
                ease:
                    CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });

        },
    });


    // Define minimum and maximum values for BPM
    const minBPM = 26; // Minimum BPM
    const maxBPM = 452; // Maximum BPM
    const startBPM = 226; // Starting BPM in the middle of the range
    Tone.Transport.bpm.value = startBPM;

    // Slider 
    gsap.set(".rangeSliderSvg", { transformOrigin: "center", autoAlpha: 0 });
    gsap.set(".__Handle", { transformOrigin: "center", pointerEvents: "none" });
    gsap.set(".TrackGroup", { transformOrigin: "center", scaleY: 1.25, scaleX: 0.875, autoAlpha: 0, });


    gsap.set("g.arrow-group line", { transformOrigin: "center", opacity: 0 });


    // Set up a looping animation for pre-click effect
    const preClickAnimation = gsap.to(".circlePalm", {
        scale: "+=2.5",
        transformOrigin: "center",
        delay: 2,
        duration: 1.25,
        ease: "power4.in",
        repeat: -1, // Repeat indefinitely until clicked
        yoyo: true  // Creates a pulsing effect
    });

    // Shared state for active status
    let isActive = false;

    // Define the common function for handling the click event
    function handlePlayPauseClick(event) {
        event.stopPropagation();

        // Toggle the shared active state
        isActive = !isActive;

        // Stop the pre-click animation on first click
        preClickAnimation.kill();

        // Update the active class on all related elements
        document.querySelectorAll('.playThisHand, .--rangeSlider h2').forEach(el => {
            el.classList.toggle("active", isActive);
        });

        if (isActive) {
            // Start the Tone context and begin playing
            Tone.start().then(() => {
                Tone.Transport.start();
            });

            gsap.to(".squarePalm", {
                duration: 0.125,
                scale: 2.5,
                autoAlpha: 1,
                ease: CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.to(".circlePalm", {
                duration: 0.25,
                scale: 0,
                ease: CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.set(".rangeSliderSvg", { transformOrigin: "center", autoAlpha: 1, delay: 0.375 });
            gsap.to(".TrackGroup", { delay: 2.5, duration: 0.25, autoAlpha: 1 });
            gsap.to(".__Handle", { pointerEvents: "all", scaleY: 1 });

            // Animate arrow-group lines
            gsap.to("g.arrow-group line:nth-of-type(1), g.arrow-group line:nth-of-type(3)", {
                opacity: 1,
                transformOrigin: "center",
                yoyo: true,
                repeat: 1,
                repeatDelay: 0.125,
                strokeDashoffset: 10,
                duration: 1,
                delay: 0.5,
                ease: "power4.in",
            });
            gsap.to("g.arrow-group line:nth-of-type(2), g.arrow-group line:nth-of-type(4)", {
                opacity: 1,
                transformOrigin: "center",
                yoyo: true,
                repeat: 1,
                repeatDelay: 0.125,
                strokeDashoffset: 10,
                duration: 1.5,
                ease: "power4.in",
            });
            gsap.to(".--rangeSlider h2", { autoAlpha: 0, duration: 0.125 });
        } else {
            // Stop playing the loop
            Tone.Transport.stop();

            gsap.to("#right, #left", {
                rotate: 0,
                duration: 0.5,
                yoyo: true,
                repeat: 0,
                ease: CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.to(".squarePalm", {
                duration: 0.125,
                autoAlpha: 0,
                scale: 3,
                ease: CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.to(".circlePalm", {
                duration: 0.25,
                scale: 5,
                ease: CustomEase.create("custom", "M0,0,C0.083,0.294,0.061,1.077,0.438,1.136,0.736,1.182,0.826,1,1,1")
            });
            gsap.set("g.arrow-group line", { transformOrigin: "center", autoAlpha: 0 });
        }
    }

    // Attach the click event to `.playThisHand` elements
    document.querySelectorAll('.playThisHand').forEach(playButton => {
        playButton.addEventListener("click", handlePlayPauseClick);
    });

    // Attach the click event to `.--rangeSlider h2` elements
    document.querySelectorAll('.--rangeSlider h2').forEach(button => {
        button.addEventListener("click", handlePlayPauseClick);
    });

    // Flag to track if the slider has been dragged
    let sliderDragged = false;

    // Store the initial position of the slider handle
    const initialHandlePosition = gsap.getProperty(".HandleGroup", "x");

    // Initialize the Draggable with the correct bounds and settings
    Draggable.create(".HandleGroup", {
        type: "x",
        bounds: ".TrackGroup",
        edgeResistance: 1, // Adjust edge resistance as needed
        throwProps: true, // Enable throwProps for smoother dragging

        onDrag: function () {
            // Calculate the percentage of the handle's position relative to the initial position
            const percentage = (this.x - initialHandlePosition) / this.maxX;

            // Calculate the BPM based on the percentage and starting BPM
            const scaledBPM = startBPM + percentage * (maxBPM - minBPM);

            // Update Tone.js Transport BPM
            Tone.Transport.bpm.value = Math.max(minBPM, Math.min(maxBPM, scaledBPM));

            // Update GSAP scale on drag
            // gsap.to(".__Handle", {
            //     scaleX: 0.75 + percentage * 0.375, // Adjust scale based on percentage
            //     scaleY: 0.75 + percentage * 0.125, // Adjust scale based on percentage
            //     duration: 0.1,
            //     ease: "power1.inOut", // Use ease appropriate for scale animation
            // });

            // Adjust sustain and decay of synths based on slider position
            const newSustain = Math.max(0, Math.min(1, 0.5 - percentage * 1)); // Clamp between 0 and 1
            const newDecay = Math.max(0, Math.min(0.01, 0.475 + percentage * 0.4)); // Clamp between 0 and 1
            synthL.envelope.sustain = newSustain;
            synthL.envelope.decay = newDecay;
            synthR.envelope.sustain = newSustain;
            synthR.envelope.decay = newDecay;
        },

        onDragEnd: function () {
            // Check if the slider was dragged (not just clicked)
            if (sliderDragged) {
                // Reset the flag
                sliderDragged = false;

                // Update GSAP scale to the minimum scale
                gsap.to(".__Handle", {
                    scaleY: 0.875 + percentage * 0.125,
                    duration: 1,
                    ease: "power1.inOut", // Use ease appropriate for scale animation
                });
            }
        },
    });

}, false);







